/* ============================================================================
   KOTT Lab — Story Hero · v4 "ink editorial" — entrance module
   ----------------------------------------------------------------------------
   The section's inline script arms the hero during parse (`.is-armed`). This
   module plays it (`.is-in`) once the intro loader is done — or straight
   away on a repeat visit — and marks each milestone dot `.is-landed` when its
   travel transition ends so the CSS squash fires exactly at the stop.
   Reduced motion (OS pref or the accessibility widget): never armed; if it
   flips mid-play, everything snaps to the resting frame. No rAF loops.
   ============================================================================ */
(function () {
  var root = document.querySelector('.ksh');
  if (!root) return;

  var isReduced = function () {
    return window.kottReduceMotion
      ? window.kottReduceMotion()
      : (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  var played = false;

  function rest() {
    root.classList.remove('is-armed', 'is-in');
    root.querySelectorAll('.ksh__mkDot.is-landed').forEach(function (d) { d.classList.remove('is-landed'); });
  }

  function play() {
    if (played) return;
    played = true;
    if (isReduced()) { rest(); return; }
    if (!root.classList.contains('is-armed')) root.classList.add('is-armed');
    // two frames so the armed state is committed before the transitions start
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('is-in');
        root.dispatchEvent(new CustomEvent('ksh:play'));
      });
    });
  }

  // land the dot the moment its wrapper stops growing
  root.querySelectorAll('.ksh__mk').forEach(function (mk) {
    var dot = mk.querySelector('.ksh__mkDot');
    if (!dot) return;
    var landed = false;
    var land = function () {
      if (landed || isReduced()) return;
      landed = true;
      dot.classList.add('is-landed');
    };
    mk.addEventListener('transitionend', function (e) {
      // Chrome reports the physical name for a logical transition
      if (e.target === mk && /^(inline-size|width|height)$/.test(e.propertyName)) land();
    });
    // safety: if transitionend never fires (tab hidden), land on the CSS timing
    var mi = parseFloat(getComputedStyle(mk).getPropertyValue('--mi')) || 0;
    root.addEventListener('ksh:play', function () { setTimeout(land, 1000 + mi * 300 + 1250 + 120); }, { once: true });
  });

  // Live response to the accessibility "stop animations" toggle.
  function onReduceChange(e) {
    if (e.detail && e.detail.reduced) { played = true; rest(); }
  }
  if (window.__kshReduceHandler) window.removeEventListener('kott:reduce-motion-change', window.__kshReduceHandler);
  window.__kshReduceHandler = onReduceChange;
  window.addEventListener('kott:reduce-motion-change', onReduceChange);

  if (isReduced()) { rest(); return; }

  if (window.__kottLoaderDone) {
    setTimeout(play, 60);
  } else {
    document.addEventListener('kott:loader:done', function () { setTimeout(play, 60); }, { once: true });
    // loader skipped or stuck — never strand the hero
    setTimeout(play, 2600);
  }
})();
